import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class DapipInstitutionCampusViewModel extends Model {
  @attr declare dapipId: number;
  @attr declare parentDapipId: number;
  @attr declare address: string;
  @attr declare locationName: string;
  @attr declare locationType: string;

  [Type] = 'dapip-institution-campus-view' as const;
}
